<div class="grid grid-cols-12 p-3 mb-5 bg-gray-50">
  <div class="col-span-12 lg:col-span-6 border-l-4 border-gray-700 pl-4">
    <div class="grid">
      <p class="text-xs uppercase text-gray-500 font-medium tracking-wide">
        Social Posts Section
      </p>
      <h2 class="text-xl font-bold text-nowrap text-gray-700 leading-tight">
        Repeat
      </h2>
    </div>
  </div>
</div>

<div class="grid grid-cols-12 items-start">
  <div class="col-span-12 2xl:col-span-9 ps-3">
    <div *ngIf="isDataLoaded">
      <div class="bg-white border border-gray-200 rounded-2xl p-3 w-full">
        <div class="grid grid-cols-9 gap-4 items-start">
          <!-- LEFT BUTTONS (col-span-1) -->
          <div class="hidden md:flex flex-col col-span-1 items-center">
            <span class="block">
              <button
                mat-icon-button
                class="manage-post-btn my-2"
                (click)="backToPrevPage()"
                matTooltip="Back"
                aria-label="Back"
              >
                <mat-icon svgIcon="back"></mat-icon>
              </button>
            </span>

            <span *ngIf="enableDelete === 1" class="block">
              <button
                mat-icon-button
                class="manage-post-btn my-2"
                (click)="openDeleteConfirm()"
                [disabled]="isDeleteDisabled"
                matTooltip="Delete"
                matTooltipPosition="left">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </span>

            <div class="my-4"></div>

            <span class="block">
              <button
                mat-icon-button
                class="manage-post-btn my-2"
                (click)="prevPost()"
                [disabled]="prevId === null"
                matTooltip="Previous"
                [matTooltipDisabled]="prevId === null">
                <mat-icon>skip_previous</mat-icon>
              </button>
            </span>

            <span class="block">
              <button
                mat-icon-button
                class="manage-post-btn my-2"
                (click)="nextPost()"
                [disabled]="nextId === null"
                matTooltip="Next"
                [matTooltipDisabled]="nextId === null">
                <mat-icon>skip_next</mat-icon>
              </button>
            </span>
          </div>

          <!-- FORM -->
          <div class="col-span-9 md:col-span-8">

            <!-- OUTER CARD -->
            <div class="relative w-full rounded-3xl bg-white p-4 sm:p-6">

              <!-- INNER CARD -->
              <form
                [formGroup]="repeatForm"
                (ngSubmit)="submit()"
                class="relative p-10 bg-white w-full max-w-2xl mx-auto">

                <!-- Header -->
                <div class="text-center mb-6">
                  <h1 class="text-3xl font-extrabold text-gray-800 mb-3">
                    {{ isEditMode ? 'Edit Repeat Functionality' : 'Apply Repeat Functionality' }}
                  </h1>
                  <p class="text-gray-500 text-sm">
                    {{
                      isEditMode
                        ? 'Update the repeat functionality for this post'
                        : 'Select the repeat functionality that will be attached to this post'
                    }}
                  </p>
                </div>

                <!-- ID, Title & Description -->
                <div class="text-sm mb-6">
                  <div class="font-semibold text-gray-700 mb-3">
                    <span class="mr-2">Post ID:</span>
                    <span class="font-normal text-gray-500">{{ postId }}</span>
                  </div>
                  <div class="font-semibold text-gray-700 mb-3">
                    <span class="mr-2">Post title:</span>
                    <span class="font-normal text-gray-500">{{ repeatForm.get('post_title')?.value }}</span>
                  </div>
                  <div class="font-semibold text-gray-700 mb-3">
                    <span class="mr-2">Post Description:</span>
                    <span class="font-normal text-gray-500">{{ repeatForm.get('post_description')?.value }}</span>
                  </div>

                  <!-- AI Generated Toggle -->
                  <div class="mt-4 flex items-center">
                    <mat-slide-toggle formControlName="ai_generated_repeat">
                      AI Generated
                    </mat-slide-toggle>
                    <span
                      matTooltip="If enabled, the repeated post will be generated by AI each time."
                      class="ml-2 inline-flex items-center justify-center w-4 h-4 rounded-full bg-blue-600 text-white text-xs font-bold leading-none">
                      i
                    </span>
                  </div>
                </div>

                <!-- Repeat Days -->
                <div class="w-full max-w-sm mb-6">
                  <label class="block text-sm font-semibold text-gray-700 mb-2">🔁 Choose Repeat Days</label>
                  <select
                    #intervalSelect
                    formControlName="interval_days"
                    (change)="onIntervalChange(intervalSelect.value)"
                    class="w-full border-gray-200 rounded-xl px-3 py-1.5 bg-gray-50 text-sm shadow-sm transition
                          focus:ring-2 focus:ring-blue-500 focus:border-blue-500 cursor-pointer"
                    [ngClass]="repeatForm.get('custom_repeat')?.value ? 'text-gray-400 hover:text-gray-600' : 'text-gray-700'">
                    <option value="" disabled>Select Repeat Days</option>
                    <option value="7">7 days</option>
                    <option value="14">14 days</option>
                    <option value="30">30 days</option>
                  </select>
                </div>

                <!-- Custom -->
                <div class="w-full max-w-sm mb-6">
                  <label class="block text-sm font-semibold text-gray-700 mb-2">⚙️ Choose Custom</label>
                  <select
                    #customSelect
                    formControlName="custom_repeat"
                    (change)="onCustomChange(customSelect.value)"
                    class="w-full border-gray-200 rounded-xl px-3 py-1.5 bg-gray-50 text-sm shadow-sm transition
                          focus:ring-2 focus:ring-blue-500 focus:border-blue-500 cursor-pointer"
                    [ngClass]="repeatForm.get('interval_days')?.value ? 'text-gray-400 hover:text-gray-600' : 'text-gray-700'">
                    <option value="" disabled>Select Custom Repeat Method</option>
                    <option value="weekly">Weekly</option>
                    <option value="monthly">Monthly</option>
                    <option value="yearly">Yearly</option>
                  </select>
                </div>

                <!-- Weekly Picker -->
                <div *ngIf="repeatForm.get('custom_repeat')?.value === 'weekly'" class="w-full max-w-sm mb-6">
                  <label class="block text-sm font-semibold text-gray-700 mb-2">📅 Weekly: Select Day / Time</label>
                  <div class="mb-4">
                    <select
                      formControlName="repeat_weekday"
                      class="w-full border-gray-200 rounded-xl px-3 py-1.5 bg-gray-50 text-sm shadow-sm mb-3">
                      <option *ngFor="let d of weekdays; let i = index" [value]="i">{{ d }}</option>
                    </select>
                    <input
                      type="time"
                      formControlName="repeat_time"
                      class="w-full border-gray-200 rounded-xl px-3 py-1.5 bg-gray-50 text-sm shadow-sm" />
                  </div>
                </div>

                <!-- Monthly Picker -->
                <div *ngIf="repeatForm.get('custom_repeat')?.value === 'monthly'" class="w-full max-w-sm mb-6">
                  <label class="block text-sm font-semibold text-gray-700 mb-2">📅 Monthly: Select Month / Day / Time</label>
                  <div class="mb-4">
                    <select
                      formControlName="repeat_month"
                      class="w-full border-gray-200 rounded-xl px-3 py-1.5 bg-gray-50 text-sm shadow-sm mb-3">
                      <option *ngFor="let m of months; let i = index" [value]="i+1">{{ m }}</option>
                    </select>
                    <select
                      formControlName="repeat_day"
                      class="w-full border-gray-200 rounded-xl px-3 py-1.5 bg-gray-50 text-sm shadow-sm mb-3">
                      <option *ngFor="let d of days" [value]="d">{{ d }}</option>
                    </select>
                    <input
                      type="time"
                      formControlName="repeat_time"
                      class="w-full border-gray-200 rounded-xl px-3 py-1.5 bg-gray-50 text-sm shadow-sm" />
                  </div>
                </div>

                <!-- Yearly -->
                <div *ngIf="repeatForm.get('custom_repeat')?.value === 'yearly'" class="w-full max-w-sm mb-6">
                  <label class="block text-sm font-semibold text-gray-700 mb-2">🕒 Yearly: Select Date & Time</label>
                  <input
                    type="datetime-local"
                    formControlName="repeat_date"
                    class="w-full border-gray-200 rounded-xl px-3 py-1.5 bg-gray-50 text-sm shadow-sm" />
                </div>

                <!-- Enable Repeat -->
                <div class="flex items-center mb-6" [hidden]="!isEditMode">
                  <mat-slide-toggle formControlName="enable_repeat">
                    Enable Repeat
                  </mat-slide-toggle>
                </div>

                <!-- Submit -->
                <div class="pt-6 flex justify-center">
                  <button
                    type="submit"
                    class="cursor-pointer inline-flex items-center gap-2 px-8 py-3 bg-gradient-to-r from-blue-600 to-blue-500 text-white text-sm font-semibold rounded-xl shadow-md hover:from-blue-700 hover:to-blue-600 transition-all transform hover:scale-105">
                    🚀 Submit
                  </button>
                </div>

              </form>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>


<!-- SIDEBAR COLUMN -->
<div
  class="hidden md:block col-span-12 2xl:col-span-3 px-3 2xl:px-6 mt-6 2xl:mt-0"
  *ngIf="posts.length > 0 || alerts.length > 0">

  <div class="grid grid-cols-1 gap-5">

    <app-latest-posts
      [posts]="posts"
      [maxSidebarCards]="maxSidebarCards"
      [naPlaceholder]="naPlaceholder"
      (viewPost)="viewRow($event)">
    </app-latest-posts>

    <app-latest-alerts
      [alerts]="alerts"
      [maxSidebarCards]="maxSidebarCards"
      [naPlaceholder]="naPlaceholder"
      (viewAlert)="viewAlert($event)">
    </app-latest-alerts>

  </div>

</div>